import { useEffect, useState } from 'react';
import useIsMobile from '../../../../utils/useIsMobile';

const useScroll = () => {
  const isMobile = useIsMobile();
  const [isTop, setIsTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const offset = isMobile ? 64 : 80;
      if (window.pageYOffset >= offset) {
        setIsTop(false);
      } else {
        setIsTop(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { isTop };
};

export default useScroll;
